import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentUser } from '../utils/auth';
import { AppButton } from './ui';

const NotFound = () => {
  const navigate = useNavigate();
  const navigateHome = () => {
    const currentUser = getCurrentUser();
    if (currentUser && currentUser.usertype === 'student') {
      navigate('/s/dashboard');
      return;
    } else if (currentUser && currentUser.usertype === 'instructor') {
      navigate('/i/');
      return;
    } else if (currentUser && currentUser.usertype === 'admin') {
      navigate('/');
      return;
    }
    navigate('/');
  };
  return (
    <div className="error-404-container d-flex flex-column justify-content-center align-items-center">
      <h1 className="error-404-title">404</h1>
      <p className="mb-4 error-404-subtitle">Page Not Found</p>
      <AppButton className="error-404-btn" onClick={navigateHome}>
        Go Home
      </AppButton>
    </div>
  );
};

export default NotFound;
